module.exports = __webpack_public_path__ + "img/PHF_logo_arrow-011.9da7fa42.svg";